import AnalyticsBase from './AnalyticsBase';

class AdditionalServicesEvent extends AnalyticsBase {
  service_type: string;

  service_name: string;

  additional_service: string;

  remove?: boolean;
}

export default AdditionalServicesEvent;
